@if (messages().length > 0) {
  <app-alert-toast severity="error" live="assertive">
    <div class="form-error-summary" tabindex="-1">
      <p class="form-error-summary__title">{{ title() }}</p>

      <ul class="form-error-summary__list">
        @for (message of messages(); track message.emphasis + message.detail) {
          <li>
            <strong class="form-error-summary__emphasis">{{ message.emphasis }}</strong>
            {{ message.detail }}
          </li>
        }
      </ul>
    </div>
  </app-alert-toast>
}
